import React from "react";

const ErroreElement = () => {
  return (
    <div className="flex justify-center items-center  mt-28">
      <div>
        <h1 style={{ fontSize: "90px" }} className=" text-primary font-bold ">
          404 Not Found!!!!
        </h1>
      </div>
    </div>
  );
};

export default ErroreElement;
